module.exports = __webpack_public_path__ + "images/icon-plus.a057b4.svg";